import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';


import {
  HeaderComponent,
  NavComponent,
  FooterComponent,
  LayoutService,
  NavigationItem
} from '../../projects/components/src/public-api';

import { CalAngularService } from '@cvx/cal-angular';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    NavComponent,
    FooterComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
  
export class AppComponent implements OnInit, OnDestroy {

  welcome = 'Welcome!';
  isLoading = true;
  isAuthorized = false;

  navigationItems: NavigationItem[] = [
    { label: 'builder', link: '/builder' }
  ];

  accessToken?: string;
  loadingToken = false;
  tokenError?: string;

  constructor(private layout: LayoutService, private CAL: CalAngularService,private router: Router) {
    this.welcome = this.CAL.getAccount()?.name ?? 'Welcome!';
  }

  
  async ngOnInit(): Promise<void> {

    this.isLoading = true;  
    try {  
      // Allow CAL/MSAL startup to settle
      await new Promise(resolve =>
        setTimeout(resolve, 1200)
      );
  
      const result =
        await this.checkUserInGroup(
          environment.security.copilotAccessGroupId
        );
  
      if (!result.hasAccess) {  
        await this.router.navigate([
          '/access-denied'
        ]);  
        return;
      }  
    } finally {  
      this.isLoading = false;
    }
  }
  

  ngOnDestroy(): void {}

  private async checkUserInGroup(
    groupId: string
  ): Promise<{
    hasAccess: boolean;
    hasError: boolean;
  }> {
  
    try {
  
      const account = this.CAL.getAccount();
      console.log('Claims:',account?.idTokenClaims);


      if (!account) {  
        console.warn(
          'Authorization check skipped: no CAL account available.'
        );
  
        return {
          hasAccess: false,
          hasError: true
        };
      }
  
      const tokenResult = await firstValueFrom(
        this.CAL.getAADToken([])
      );
  
      let token: string | null = null;
  
      if (typeof tokenResult === 'string') {
  
        token = tokenResult;
  
      } else if (
        tokenResult &&
        typeof tokenResult === 'object' &&
        'accessToken' in tokenResult
      ) {
  
        token = (tokenResult as any).accessToken;
      }
  
      if (!token) {
  
        console.error(
          'Authorization failed: no access token returned.'
        );
  
        return {
          hasAccess: false,
          hasError: true
        };
      }
  
      const response = await fetch(
        'https://graph.microsoft.com/v1.0/me/checkMemberGroups',
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            groupIds: [groupId]
          })
        }
      );
  
      if (!response.ok) {
  
        console.error(
          'Authorization failed. Graph response:',
          response.status
        );
  
        return {
          hasAccess: false,
          hasError: true
        };
      }
  
      const result = await response.json();
  
      return {
        hasAccess:
          (result?.value || []).includes(groupId),
        hasError: false
      };
  
    } catch (error) {
  
      console.error(
        'Authorization error:',
        error
      );
  
      return {
        hasAccess: false,
        hasError: true
      };
    }
  }

}